import { useChatWorkflowShared } from "@intelligems/ig-plugin/builder";
import { UiStreamAction } from "@intelligems/ig-types";
import { aiApiClient } from "@src/api/ai-api";
import { handleAiChatAction } from "@src/store/slices/aiChat";
import { useDispatch } from "@src/store";

export const useSitewideAnalyticsChat = () => {
  const dispatch = useDispatch();

  const chatWorkflow = useChatWorkflowShared(
    aiApiClient,
    (data: UiStreamAction) => dispatch(handleAiChatAction(data))
  );
  return { chatWorkflow };
};
